import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config-service';
import { Menu } from 'src/app/models/menu.model';

@Injectable()
export class MenuService {
  constructor(private http: HttpClient) { }

  configService = inject(ConfigService);

  loadMenu(langIso: string): Observable<Menu[]> {
    const url = this.configService.readConfig().baseUrlInfrastructure
      + '/menu/GetMenuWithPagination?LanguageIso='
      + langIso;
    return this.http.get<Menu[]>(url);
  }
}
